import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import styled from 'styled-components';

const Container = styled.div`
  height: 70px;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  padding: 0 30px 0 30px;
  background-color: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(3px);
  margin-bottom: 250px;
`;

const Ul = styled.ul`
  display: flex;
  align-items: center;
  height: 100%;
`;

const Title = styled.span`
  width: 80%;
  font-size: 30px;
  font-weight: 800;
  color: #e50914;
  margin-left: 20px;
  @media (max-width: 768px) {
    font-size: 24px;
    margin-left: 0;
  }
`;

const Li = styled.li`
  width: 140px;
  font-size: 20px;
  transition: all 0.2s ease-in-out;
  display: flex;
  justify-content: center;
  height: 100%;
  align-items: center;
  border-bottom: 3px solid
    ${props => (props.current ? '#E30914' : 'transparent')};
  color: ${props => (props.current ? '#E50914' : 'white')};
  opacity: ${props => (props.current ? '1' : '0.6')};
`;

const Header = ({ location: { pathname } }) => {
  return (
    <Container>
      <Ul>
        <Title>
          <Link to="/">ScFlix</Link>
        </Title>
        <Li current={pathname === '/'}>
          <Link to="/">홈</Link>
        </Li>
        <Li
          current={
            pathname === '/tv' ||
            pathname === '/tv/airing-today' ||
            pathname === '/tv/top-rated'
          }
        >
          <Link to="/tv">TV </Link>
        </Li>
        <Li
          current={
            pathname === '/movie' ||
            pathname === '/movie/now-playing' ||
            pathname === '/movie/top-rated'
          }
        >
          <Link to="/movie">영화</Link>
        </Li>
        <Li current={pathname.includes('/search')}>
          <Link to="/search">검색</Link>
        </Li>
      </Ul>
    </Container>
  );
};

export default withRouter(Header);
